import { type IChartDataset } from './ChartDataset';

interface ILineChartData<T> {
    title: string;
    subtitle?: string;
    datasets: IChartDataset<T>[];
}

export class LineChartData<T> implements ILineChartData<T> {
    datasets: IChartDataset<T>[];
    title: string;
    subtitle?: string;

    public constructor(item: ILineChartData<T>) {
        this.datasets = item.datasets;
        this.title = item.title;
        this.subtitle = item.subtitle;
    }
}
